import Paginator from '@dealroadshow/uikit/core/components/Paginator';
import DataTable, { dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';

import ArticlesTileContextProvider, {
  useArticlesTileContext,
} from '@/finsight/application/CreditFlowResearch/Articles/ArticlesTile/ArticlesTileContext';
import { Link } from '@/Framework/Router/Next/Link';
import { useGetLinkToAllArticles } from '@/finsight/ui/components/creditFlow/articles/common/useGetLinkToAllArticles';
import TileHeader from './TileHeader';
import columns from './columns';

import styles from './articlesTile.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';

const EmptyMessage = ({ type }) => {
  const { link } = useGetLinkToAllArticles(type);

  return (
    <div className={ styles.emptyMessage }>
      Explore all other&nbsp;
      <Link to={ link }>Commentary & Deal Flow</Link>
    </div>
  );
};

const ArticlesTile = ({ themeType }) => {
  const {
    articlesData: {
      collection,
      totalCount,
      perPage,
      page,
      isFetching,
    },
    onPageChange,
  } = useArticlesTileContext();
  return (
    <div className={ styles.container }>
      <TileHeader />
      {
        collection.length === 0 ? (
          <div className={ cardStyles.cardInner }>
            <EmptyMessage type={ themeType } />
          </div>
        ) : (
          <div className={ styles.tableWrapper }>
            <DataTable
              dataTest="bwicSummaryDataTable"
              columns={ columns }
              data={ collection }
              loadingComponent={ Spinner }
              isFetching={ isFetching }
              className={ dataTableStyles.isHoverable }
            />
            <Paginator
              className={ cardStyles.cardInner }
              dataTest="bwicSummaryTable"
              page={ page }
              perPage={ perPage }
              totalCount={ totalCount }
              onPageChange={ ({ selected }) => onPageChange(selected) }
              isItemsPerPageVisible={ false }
            />
          </div>
        )
      }
    </div>
  );
};

export default ({
  initialData,
  themeType,
  isSubscribeButtonVisible,
}) => {
  return (
    <ArticlesTileContextProvider
      initialData={ initialData }
      themeType={ themeType }
      isSubscribeButtonVisible={ isSubscribeButtonVisible }
    >
      <ArticlesTile themeType={ themeType } />
    </ArticlesTileContextProvider>
  );
};
